import { useState } from 'react';
import { readInterfaceTheme, saveInterfaceTheme, type InterfaceTheme } from './interface-theme';

export function useInterfaceTheme() {
  const [theme, setTheme] = useState<InterfaceTheme>(() => {
    try { return readInterfaceTheme(window.localStorage); } catch { return 'light'; }
  });
  const chooseTheme = (value: InterfaceTheme) => {
    setTheme(value);
    try { saveInterfaceTheme(window.localStorage, value); } catch { /* Storage may be unavailable. */ }
  };
  return { theme, chooseTheme };
}

export function ThemeChoice({ theme, onChange }: { theme: InterfaceTheme; onChange: (value: InterfaceTheme) => void }) {
  return <label className="interface-theme"><span className="sr-only">Interface theme</span>
    <select value={theme} onChange={event => onChange(event.target.value as InterfaceTheme)}>
      <option value="light">Light</option><option value="dark">Dark</option>
    </select>
  </label>;
}
